import { Button, List, Typography } from '@material-ui/core';
import React from 'react';
import {
  InfiniteScroll,
  InfiniteScrollProps,
} from '@jupiterone/jupiter-web-toolkit';
export interface AccountPageListItemRendererInput<T> {
  classes: any;
  key: number;
  item: T;
  onSelect: any;
}

interface Props<T> {
  classes: any;
  onSelect: any;
  titleText: string;
  infiniteScrollProps?: InfiniteScrollProps;
  addText: string;
  onAdd: () => void;
  items: T[];
  itemRenderer: (input: AccountPageListItemRendererInput<T>) => JSX.Element;
}

const AccountPageList = <T extends {}>({
  itemRenderer,
  items,
  onAdd,
  addText,
  titleText,
  onSelect,
  classes,
  infiniteScrollProps,
}: Props<T>) => {
  return (
    <div>
      <div className={classes.headerLayout}>
        <Typography variant="h6" className={classes.groupPanelSubheaderText}>
          {titleText}
        </Typography>
        <Button
          variant="outlined"
          size="small"
          classes={{ root: classes.button, disabled: classes.buttonDisabled }}
          onClick={onAdd}
        >
          {addText}
        </Button>
      </div>
      <List>
        {infiniteScrollProps ? (
          <InfiniteScroll
            scrollContainer="parent"
            scrollOffset={1000}
            {...infiniteScrollProps}
          >
            {items.map((item: T, i: number) => {
              return itemRenderer({
                classes,
                key: i,
                item,
                onSelect,
              });
            })}
          </InfiniteScroll>
        ) : (
          items.map((item: T, i: number) =>
            itemRenderer({
              classes,
              key: i,
              item,
              onSelect,
            })
          )
        )}
      </List>
    </div>
  );
};
export default AccountPageList;
